/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/jquery/jquery.colorbox-min.js"/>
/// <reference path="/js/lib/jquery/jquery.placeholder.js"/>
/// <reference path="/js/lib/jquery/jquery.validate.min.js"/>
/// <reference path="/js/lib/jquery/jquery.validate.unobtrusive.min.js"/>
/// <reference path="/js/lib/jquery/jquery.fileDownload.js"/>
/// <reference path="/js/components/BotDetect.js"/>
/// <reference path="/js/components/ui/Colorbox.js"/>
/// <reference path="/js/components/ui/ColorboxDownloader.js"/>
/// <reference path="/js/lib/lodash.js"/>

(function(_) {
  "use strict";

  $(document).ready(function() {
    var detect,
      selectors,
      lightbox,
      $placeholders = $(".emailLightbox input, .emailLightbox textarea"),
      $vizContainer = $("#gmap-container, #data-table-container"),
      isEventFired = false; // flag for manually checking if image download event has fired

    // for the moment, trigger the ondataavailable event for the sake of the IE image download
    $vizContainer.on("initial-render-complete", function() {
      setTimeout(function() {
        fireEvent();
      }, 1500);
    });
    // fire the event in 10 seconds no matter what
    setTimeout(function() {
      fireEvent();
    }, 10000);

    function fireEvent() {
      if (isEventFired !== true) {
        // fireEvent only works for IE, hence WebBrowser control
        if ($vizContainer[0] && $vizContainer[0].fireEvent) {
          $vizContainer.get(0).fireEvent("ondataavailable");
        }
        isEventFired = true;
      }
    }

    // set up the print button
    $("#printPage").on("click", function() {
      window.print();
    });

    // set up the twitter/FB buttons/links
    $(
      ".option-icon-link.sprites.icon-share, .option-icon-link.sprites.icon-tweet, .riskrank-tweet, .riskrank-share"
    ).on("click mousedown", function() {
      var $self = $(this),
        selfHref = $self.attr("href"),
        changeLink,
        newHref;

      changeLink = function(href, firstStringSeparator, lastStringSeparator) {
        var firstString, lastString, urlIndex, titleIndex, stagedHref;

        urlIndex = href.indexOf(firstStringSeparator);
        titleIndex = lastStringSeparator
          ? href.indexOf(lastStringSeparator)
          : href.length;
        firstString = href.substring(0, urlIndex);
        lastString = href.substring(titleIndex, href.length);
        stagedHref =
          firstString +
          firstStringSeparator +
          encodeURIComponent(document.location) +
          lastString;

        return stagedHref;
      };

      if ($self.attr("class").indexOf("share") > 0) {
        // fb link
        //newHref = changeLink(selfHref, "&p[url]=", "&p[title]=");
        return;
      }
      else {
        //twitter link
        newHref = changeLink(selfHref, "&url=", "&counturl=");
      }

      $self.attr("href", newHref);
    });

    //set up the IE placeholders
    $placeholders.placeholder();

    detect = new ccc.botDetection.Detection("NonShare");
    detect.detectBot(3000);

    selectors = {
      $link: $("#emailLink"),
      $initialForm: $("#initialEmailForm"),
      $successForm: $("#successEmailForm"),
      $waitingForm: $("#waitingEmailForm"),
      $failureForm: $("#failureEmailForm"),
      $failureEmailP: $("#failureEmailP"),
      $mainForm: $("#shareEmailForm"),
      $friendEmailAddressBody: $("#friendEmailAddressBody")
    };

    // a placeholder flag to resolve conflicts between placeholder and validate plugins
    var multipleChildren = false;
    /**
     * A "lambda" that runs after a post is issued successfully.
     */
    var onPostSuccess = function() {
      var i;

      if (multipleChildren === false) {
        multipleChildren =
          selectors.$friendEmailAddressBody.children().length > 2;
      }

      // must manually reset the friends' detail section
      if (multipleChildren === true) {
        // remove all but the first two children of the tbody element friendEmailAddressBody
        for (
          i = selectors.$friendEmailAddressBody.children().length;
          i >= 2;
          i--
        ) {
          selectors.$friendEmailAddressBody
            .children()
            .eq(i)
            .remove();
        }
      }

      // make sure the remaining inputs are correctly "placeholdered"
      if (
        !("placeholder" in document.createElement("input")) &&
        multipleChildren === true
      ) {
        $("#friendEmailAddressBody input")
          .val("")
          .each(function() {
            var $self = $(this);

            if ($self.val().length === 0) {
              $self.css("color", "#A9A9BB");
            }
            else {
              $self.css("color", "#000000");
            }
          });
      }

      detect.detectBot(); // reset the detection after the form reset

      $placeholders.blur(); // activate the placeholder
    };
    /**
     * A "lambda" that runs after a post fails.
     */
    var onPostFailure = function(success) {
      selectors.$failureEmailP.html(success.Message);
    };

    /**
     * An instance of the lightbox object.
     */
    lightbox = new ccc.components.ui.Colorbox(
      selectors,
      { maxWidth: 800, minWidth: 580, percentageWidth: "70%" },
      { visibleClass: "emailLightbox", hiddenClass: "no-display" },
      { onPostSuccess: onPostSuccess, onPostFailure: onPostFailure }
    );

    // set up the email +/- buttons
    /**
     * Goes to the server to generate HTML for new friend addresses.
     */
    selectors.$mainForm.on("click", ".emailLightboxAdd", function() {
      var $inputs = $("#friendEmailAddressBody input[type=email]"),
        data,
        areInputsValid;

      areInputsValid = _.all($inputs, function(input) {
        return $(input).valid();
      });

      if (areInputsValid && $inputs.length < 5) {
        data = selectors.$mainForm.serialize();
        $.ajax({
          type: "POST",
          url: "/email/AddEmail",
          data: data,
          success: function(success) {
            var $addIcons, $removeIcons;

            $("#friendEmailAddressBody").html(success);

            // set up the placeholder for the new html
            $("#friendEmailAddressBody input")
              .each(function() {
                $(this).placeholder();
              })
              .blur();

            if ($inputs.length === 4) {
              // make add icon inactive, since you can't add more than 5 friends
              $addIcons = $("#shareEmailForm .emailLightboxAdd");
              $addIcons.attr("src", "/images/add_small_inactive.png");
              $addIcons.addClass("inactive");
            }
            $removeIcons = $("#shareEmailForm .emailLightboxRemove");
            // set the src of the add icon to be active
            $removeIcons.each(function() {
              if ($(this).attr("src") !== "/images/minus_small.png") {
                $(this).attr("src", "/images/minus_small.png");
                $(this).removeClass("inactive");
              }
            });
          }
        });
      }
    });
    /**
     * Goes to the server to generate HTML for new friend addresses.
     */
    selectors.$mainForm.on("click", ".emailLightboxRemove", function() {
      var $inputs = $("#friendEmailAddressBody input[type=email]"),
        data;

      if ($inputs.length > 1) {
        // something valid to remove
        data = selectors.$mainForm.serialize();
        $.ajax({
          type: "POST",
          url: "/email/RemoveEmail",
          data: data,
          success: function(success) {
            var $removeIcons, $addIcons;

            $("#friendEmailAddressBody").html(success);

            // set up the placeholder for the new html
            $("#friendEmailAddressBody input")
              .each(function() {
                $(this).placeholder();
              })
              .blur();

            if ($inputs.length === 2) {
              // make remove icon inactive again, since we're back down to one
              $removeIcons = $("#shareEmailForm .emailLightboxRemove");
              $removeIcons.attr("src", "/images/minus_small_inactive.png");
              $removeIcons.addClass("inactive");
            }
            $addIcons = $("#shareEmailForm .emailLightboxAdd");
            // set the src of the add icon to be active
            $addIcons.each(function() {
              if ($(this).attr("src") !== "/images/add_small.png") {
                $(this).attr("src", "/images/add_small.png");
                $(this).removeClass("inactive");
              }
            });
          }
        });
      }
    });

    lightbox.show("#emailForm");

    //Clear data and error messages when closing the box.
    $("#cboxClose").on("click", function() {
      $(".field-validation-error").hide();
      $("#FullName").val("");
      $("#Email").val("");
      $("#Comments").val("Check out this data!");
      $("#EmailAddresses_0__Email").val("");
    });

    // handle the form submission
    selectors.$mainForm.submit(function() {
      var data, vizType;

      if ($(this).valid() === false) {
        return false;
      }

      // add the title of the page to the form data for the email sharing
      data =
        selectors.$mainForm.serialize() +
        "&title=" +
        $(document).attr("title") +
        "&address=" +
        escape(document.location);

      var vizTypeIdContent = $("#vizTypeId").html();

      if (vizTypeIdContent) {
        vizType = $.parseJSON(vizTypeIdContent).vizType;
        data += "&vizType=" + vizType;
      }

      lightbox.postForm(data, "/email/shareEmail");

      return false;
    });

    /**
     * Set up the download image button.
     */
    $("#downloadImage").click(function() {
      var $this = $(this);
      var loadingClass = "icon-download-image-loading";
      $this.removeClass(loadingClass);
      $this.addClass(loadingClass);

      var $error = $(".icon-download-image-error");
      $error.hide();


      var vizTypeIdContent = $("#vizTypeId").html();
      var isMap = false;
      if (vizTypeIdContent) {
        var vizType = $.parseJSON(vizTypeIdContent).vizType;
        if (vizType) {
          vizType = vizType.toLowerCase();
          isMap = (vizType && vizType.startsWith("map"));
        }
      }

      var url =
        "/image/generate?width=1200" +
        (isMap ? "&wait=true" : "") +
        "&url=" +
        encodeURIComponent(window.location.href);

      fetch(url).then(function(response){
        $this.removeClass(loadingClass);
        if (!response.ok) {
          $error.show();
          return Promise.reject(new Error("Image download failed."));
        }

        return response.blob();
      }).then(function(blob){
        var fileName = "CCC-Image.png";
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(blob, fileName);
        }
        else {
          //trick to download store a file having its URL
          var fileURL = URL.createObjectURL(blob);
          var tempLink = document.createElement("a");
          tempLink.href = fileURL;
          tempLink.target = "_blank";
          tempLink.download = fileName;
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
        }
      });
    });
  });
})(_);
